function gapiClientDriveExists() {
    var exists = false;

    try {
        exists = typeof gapi.client.drive !== 'undefined';
    } catch (e) {}

    return exists;
}

export { gapiClientDriveExists };
